import React, { useState, useEffect, useRef } from "react";

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import axios from "axios";
import moment from "moment";
import { AprobarSolicitudesdCompras } from "./modalAprobarSolicitudCompras";
import { Input, SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";

const headCells = [
  {
    id: "1",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "N°. CONTROL",
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "DESCRIPCIÓN",
    textAlign: "left",
  },
  {
    id: "3",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "FECHA",
    textAlign: "center",
  },
  {
    id: "4",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "CÓDIGO",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " OPCIONES",
    textAlign: "center",
  },
];

const TablaAprobadasSolicitudesCompra = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [aprob, setAprob] = useState(null);
  const [aprobaciones, setAprobaciones] = useState();
  const [aprodetalle, setAprodetalle] = useState();
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idaprobaciones.includes(target.value) ||
              x.comprasaprob.includes(target.value) ||
              moment
                .utc(x.fecha)
                .format("DD-MM-YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.observaciones.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const seleccionarRegistros = () => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/solicitudesdecomprasaprobadas?idefiscal=${idefiscal}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => {
        txtBuscador.current?.focus();
      });
  };

  const seleccionarSolicitudesApro = (id) => {
    let campos = "*";
    let nomtab = "aprobaciones";
    let nomid = "idaprobaciones";
    setActivate(true);
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idaprobaciones > 0) {
            setAprobaciones(response.data);
            seleccionarSolicitudesAproDetalles(id);
          } else {
            setAprobaciones();
            seleccionarSolicitudesAproDetalles(id);
          }
        }
        //setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarSolicitudesAproDetalles = (id) => {
    let campos = "*";
    let nomtab = "aprobacionesdetalle";
    let nomid = "idaprobaciones";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setAprodetalle(response.data);
            setMostrar2(true);
          } else {
            setAprodetalle();
            setMostrar2(true);
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const handleCloseSi = () => {
    setActivate(false);
  };
  const gestionar = (op, data) => (e) => {
    if (op === 4) {
      setOperacion(4);
      setAprob(data.aprobado);
      seleccionarSolicitudesApro(data.idaprobaciones);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true);
    } else if (op === 2) {
      setOperacion(op);
      setAprob(data.aprobado);
      seleccionarSolicitudesApro(data.idaprobaciones);
    }
  };
  useEffect(() => {
    seleccionarRegistros();
    txtBuscador.current?.focus();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  };

  const cerrar = () => {
    props.cerrar();
  };

  return (
    <div className="col-8 m-0 p-2 border rounded mx-auto mt-5">
      <div className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top text-light azulGradiant">
        <h3 className="fw-bold m-0">
          Aprobación de Solicitudes de Compras/Servicios
        </h3>
        <a type="button" onClick={cerrar} className="text-light fw-bold">
          Salir <i className="fas fa-times md-2"></i>
        </a>
      </div>
      <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <input
            type="text"
            className="form-control search-input form-control-sm rounded-pill"
            ref={txtBuscador}
            onChange={handleSearch}
            placeholder="Buscar..."
          />
        </div>

        <div className="col-auto m-0 p-0">
          <PrimaryButton
            icon="fas fa-plus m-0"
            onClick={gestionar(1, "")}
          ></PrimaryButton>
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "14px",
                      textAlign: "center",
                      width: "90px",
                    }}
                  >
                    {item.comprasaprob}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "14px",
                      textAlign: "left",
                      width: "auto",
                    }}
                  >
                    {item.observaciones}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "14px",
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    {moment.utc(item.fecha).format("DD-MM-YYYY")}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                      fontSize: "14px",
                    }}
                  >
                    {item.idaprobaciones}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "150px",
                      fontSize: "14px",
                    }}
                  >
                    <button
                      onClick={gestionar(4, item)}
                      className="btn btn-sm mx-1 btn-info rounded-circle"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                    <button
                      onClick={gestionar(2, item)}
                      className="btn btn-sm mx-1 btn-primary rounded-pill"
                    >
                      <i className="fa fa-print"></i>
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <AprobarSolicitudesdCompras
        show={mostrar2}
        operacion={operacion}
        aprobado={aprob}
        aprobaciones={aprobaciones}
        aprodetalle={aprodetalle}
        titulo={
          operacion === 4
            ? "Consulta de Aprobación de Solicitudes de Compras/Servicios"
            : operacion === 2
              ? "Imprimir Solicitud Aprobada"
              : "Aprobación de Solicitudes de Compras/Servicios"
        }
        onHideCancelar={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaAprobadasSolicitudesCompra;
